/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Col_FieldsInputs */

const cs_gdpr_col_fields = /** @type {(inputs: Gdpr_Col_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pole`)
};

const en_gdpr_col_fields = /** @type {(inputs: Gdpr_Col_FieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fields`)
};

/**
* | output |
* | --- |
* | "Fields" |
*
* @param {Gdpr_Col_FieldsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_col_fields = /** @type {((inputs?: Gdpr_Col_FieldsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Col_FieldsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_col_fields(inputs)
	return cs_gdpr_col_fields(inputs)
});